<template>
  <div id="app" :class="[co === true ? 'appCo' : '']">
    <header
      :class="[indiv === true ? 'headerIndiv' : '', 'header']"
      v-if="co === false"
    >
      <router-view name="header"></router-view>
    </header>
    <section
      :class="[
        indiv === true ? 'sectionWrapper' : '',
        co === true ? 'sectionConnexion' : '',
        'section-main'
      ]"
    >
      <router-view />
    </section>
    <footer
      :class="[
        indiv === true ? 'footerIndiv' : '',
        co === true ? 'footerCo' : '',
        'footer'
      ]"
    >
      <router-view name="sidebar"></router-view>
      <div v-if="co === true">V 0.1.4</div>
    </footer>
  </div>
</template>

<script>
import * as controle from "./controller/correctionEcran.js";
import screenfull from "screenfull";

function toggleFullScreen() {
  if (!document.fullscreenElement) {
    document.documentElement.requestFullscreen();
  } else {
    if (document.exitFullscreen) {
      document.exitFullscreen();
    }
  }
}

export default {
  name: "App",
  data() {
    return {
      indiv: false,
      co: false,
      clicks: Number(0)
    };
  },
  created() {
    let position = this.$route.name;
    if (
      position == "connexion" ||
      position == "Changement_Mdp" ||
      position == "Changement_Mdp2" ||
      position == "Changement_Mdp3"
    ) {
      this.co = true;
    } else if (position == "Session_Individuelle") {
      this.indiv = true;
    }/*
    if (controle.isMobileDevice() === true) {
        window.onresize(function() {
      
        $("input, textarea").bind("blur", function(e) {
          // Keyboard disappeared
          window.scrollTo(0, 1);
        });
    });
    }*/
  },
  watch: {
    $route(to, from) {
      //console.log(this.co);
      if (to.name == "Session_Individuelle") {
        this.indiv = true;
        this.co = false;
      }else if (to.name == 'Accueil' && from.name == 'connexion'){
        if (controle.isMobileDevice() === true &&  screen.width > 600){
        // This hides the address bar:
        //window.scrollTo(0, 1); 
      }
      this.co = false;   
      }else if (to.name == "connexion") {
        this.co = true;
      } else if (from.name == "connexion") {
        this.co = false;
      } else if (from.name == "Accueil") {
        this.co = false;
      } else {
        this.indiv = false;
        this.co = false;
      }
    }
  }
};
</script>

<style src="./css/style.css"></style>



// WEBPACK FOOTER //
// src/App.vue